import { useTheme, type Theme } from '../contexts/ThemeContext';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const themes: { value: Theme; label: string; icon: string }[] = [
    { value: 'glassmorphism', label: 'Glassmorphism', icon: '✨' },
    { value: 'retro-futurism', label: 'Nifty Portal', icon: '⬛' },
  ];

  return (
    <div className="relative">
      <div className="flex items-center gap-1 p-1 bg-white/10 backdrop-blur-md rounded-xl border border-white/20">
        {themes.map((t) => (
          <button
            key={t.value}
            onClick={() => setTheme(t.value)}
            className={`
              px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300
              flex items-center gap-2
              ${
                theme === t.value
                  ? 'bg-primary-600 text-white shadow-lg shadow-primary-500/50'
                  : 'text-gray-300 hover:text-white hover:bg-white/10'
              }
            `}
          >
            <span className="text-lg">{t.icon}</span>
            <span className="hidden sm:inline">{t.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
